module.exports = __webpack_public_path__ + "img/header-diamondJewelryRosegold.a726309.webp";